import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})

export class UserService {

    constructor(private http: HttpClient) { }

    private userService = environment.userService + '/v1';
    private posUserService = environment.posUserService + '/v1';

    noAuth = new HttpHeaders()
        .set('noauth', 'true')
    //********** User  APIs ************

    checkEmail(payload: any): Observable<any> {
        return this.http
            .post<any>(this.userService + "/staff/checkEmail", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getEmailData(payload: any): Observable<any> {
        return this.http
            .post<any>(this.userService + "/staff/get", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getStaffDetails(payload: any): Observable<any> {
        return this.http
            .post<any>(this.userService + "/staff/get", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    changePassword(payload: any): Observable<any> {
        return this.http
            .put<any>(this.userService + "/staff/change-password", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    createUser(payload: any): Observable<any> {
        return this.http
            .post<any>(this.userService + "/staff/signUp", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    updateUser(payload: any): Observable<any> {
        return this.http
            .put<any>(this.userService + `/staff/update`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getUserById(id: any): Observable<any> {
        return this.http
            .get<any>(this.userService + `/user/fetch/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    loginUser(payload: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/staff/login`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    sendOtp(payload: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/user/send-otp`, payload, {
                headers: this.noAuth
            })
            .pipe(catchError((err) => throwError(err)));
    }

    verifyOtp(payload: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/user/verify-otp`, payload, {
                headers: this.noAuth
            })
            .pipe(catchError((err) => throwError(err)));
    }

    createShop(payload: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/shop/add-shop`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getShopById(id: string): Observable<any> {
        return this.http
            .get<any>(this.userService + `/shop/fetch-shop/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    updateShop(payload: any): Observable<any> {
        return this.http
            .put<any>(this.userService + `/shop/update-shop?id=${payload._id}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getShopListByIds(payload: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/shop/get-shop-list`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getShopBySales(payload: any, page: any, pageSize: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/shop/get-shop-by-sales?page=${page}&pageSize=${pageSize}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getWalletReport(page: any, pageSize: any, balanceType: any): Observable<any> {
        return this.http
            .get<any>(this.userService + `/shop/wallet-report?page=${page}&pageSize=${pageSize}&balanceType=${balanceType}`)
            .pipe(catchError((err) => throwError(err)));
    }

    getTemporaryToken(payload: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/user/get-temp-access-token`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    // Warehouse

    getWarehouse(payload: any, page: any, pageSize: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/warehouse/get?page=${page}&pageSize=${pageSize}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    createWarehouse(payload: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/warehouse`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    updateWarehouse(payload: any): Observable<any> {
        return this.http
            .put<any>(this.userService + `/warehouse`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    deleteWarehouse(id: any): Observable<any> {
        return this.http
            .delete<any>(this.userService + `/warehouse/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    checkWarehouseExist(payload: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/warehouse/check-exists`, payload)
            .pipe(catchError((err) => throwError(err)));
    }
    //Shop


    getShopList(payload: any, page: any, pageSize: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/shop/get-shop?page=${page}&pageSize=${pageSize}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    deleteShop(id: any, userId: any): Observable<any> {
        return this.http
            .delete<any>(this.userService + `/shop/delete-shop?id=${id}&userId=${userId}`)
            .pipe(catchError((err) => throwError(err)));
    }

    getTotalShopCount(payload: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/shop/total`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getTotalPosShopCount(payload: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/shop/pos/total`, payload)
            .pipe(catchError((err) => throwError(err)));
    }
    activateTrial(payload: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/shop/membership/startTrial`, payload)
            .pipe(catchError((err) => throwError(err)));
    }
    endTrial(payload: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/shop/membership/endTrial`, payload)
            .pipe(catchError((err) => throwError(err)));
    }
    cancelMembership(payload: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/shop/membership/cancel`, payload)
            .pipe(catchError((err) => throwError(err)));
    }
    extendTrial(payload: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/shop/membership/extend`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    // Location

    getLocation(payload: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/location/get-location`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    addLocation(payload: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/location/add-location`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    updateLocation(payload: any): Observable<any> {
        return this.http
            .put<any>(this.userService + `/location/update-location?id=${payload._id}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    deleteLocation(payload: any): Observable<any> {
        return this.http
            .delete<any>(this.userService + `/location/delete-location?id=${payload._id}`)
            .pipe(catchError((err) => throwError(err)));
    }


    //********** Extra Charge  APIs ************

    createExtraCharge(payload: any): Observable<any> {
        return this.http.post<any>(this.userService + '/extra-charge', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getAllExtraCharge(payload: any): Observable<any> {
        return this.http.post<any>(this.userService + '/extra-charge/get?page=1&pageSize=10', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    updateExtraCharge(payload: any): Observable<any> {
        return this.http.put<any>(this.userService + '/extra-charge', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    deleteExtraCharge(deleteId: any): Observable<any> {
        return this.http.delete<any>(this.userService + '/extra-charge/' + deleteId)
            .pipe(catchError((err) => throwError(err)));
    }

    //********** Event  APIs ************

    createEvent(payload: any): Observable<any> {
        return this.http.post<any>(this.userService + '/event', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getAllEvent(payload: any): Observable<any> {
        return this.http.post<any>(this.userService + '/event/get?page=1&pageSize=10', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    deleteEvent(deleteId: any): Observable<any> {
        return this.http.delete<any>(this.userService + '/event/' + deleteId)
            .pipe(catchError((err) => throwError(err)));
    }

    getEventById(editId: any): Observable<any> {
        return this.http.get<any>(this.userService + '/event/get/' + editId)
            .pipe(catchError((err) => throwError(err)));
    }

    updateEvent(payload: any): Observable<any> {
        return this.http.put<any>(this.userService + '/event', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    //********** Pincode WhiteList  APIs ************

    addPincode(payload: any): Observable<any> {
        return this.http.post<any>(this.userService + '/pincodeWhitelist/add-pincode', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getAllPincode(payload: any): Observable<any> {
        return this.http.post<any>(this.userService + '/pincodeWhitelist/get-pincode', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    deletePincode(id: any): Observable<any> {
        return this.http.delete<any>(this.userService + '/pincodeWhitelist/delete-pincode/' + id)
            .pipe(catchError((err) => throwError(err)));
    }

    //Role

    createRole(payload: any): Observable<any> {
        return this.http.post<any>(this.userService + '/role', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getAllRole(payload: any, page: any, pageSize: any): Observable<any> {
        return this.http.post<any>(this.userService + `/role/get?page=${page}&pageSize=${pageSize}`, payload, {
            headers: this.noAuth
        })
            .pipe(catchError((err) => throwError(err)));
    }

    deleteRole(deleteId: any): Observable<any> {
        return this.http.delete<any>(this.userService + '/role/' + deleteId)
            .pipe(catchError((err) => throwError(err)));
    }

    getRoleById(editId: any): Observable<any> {
        return this.http.get<any>(this.userService + '/role/' + editId)
            .pipe(catchError((err) => throwError(err)));
    }

    updateRole(payload: any): Observable<any> {
        return this.http.put<any>(this.userService + '/role', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    //********** User Analytics ************

    getTotalUser(payload: any): Observable<any> {
        return this.http.post<any>(this.userService + '/user/total', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getTotalRole(payload: any): Observable<any> {
        return this.http.post<any>(this.userService + '/role/total', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getTotalGroup(payload: any): Observable<any> {
        return this.http.post<any>(this.userService + '/group/total', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    //********** Saloon Analytics ************

    getTotalShop(payload: any): Observable<any> {
        return this.http.post<any>(this.userService + '/shop/total', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    //****** Warehouse Ledger API ******//

    createWarehouseLedger(payload: any): Observable<any> {
        return this.http.post<any>(this.userService + '/warehouse-ledger', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    totalAmountWarehouseLedger(payload: any): Observable<any> {
        return this.http.post<any>(this.userService + '/warehouse-ledger/total', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    updateWarehouseLedger(payload: any): Observable<any> {
        return this.http.put<any>(this.userService + '/warehouse-ledger', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getWarehouseLedger(payload: any, page: any, pageSize: any): Observable<any> {
        return this.http.post<any>(this.userService + `/warehouse-ledger/get?page=${page}&pageSize=${pageSize}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getUserListByCriteria(data: any, page: any, pageSize: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/user/fetch?page=${page}&pageSize=${pageSize}`, data)
            .pipe(catchError((err) => throwError(err)));
    }

    //Modules

    addModule(payload: any): Observable<any> {
        return this.http.post<any>(this.userService + '/module/create', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getModule(): Observable<any> {
        console.log('getModule');
        return this.http.get<any>(this.userService + '/module/fetch')
            .pipe(catchError((err) => throwError(err)));
    }

    bulkUpdateGroups(payload: any): Observable<any> {
        return this.http.put<any>(this.userService + '/group/bulkupdate', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    // Wallet
    getWallet(data: any, page: any, pageSize: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/wallet/get?page=${page}&pageSize=${pageSize}`, data)
            .pipe(catchError((err) => throwError(err)));
    }

    creditToCustomer(data: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/wallet/credit-to-customer`, data)
            .pipe(catchError((err) => throwError(err)));
    }

    debitToCustomer(data: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/wallet/debit-from-customer`, data)
            .pipe(catchError((err) => throwError(err)));
    }

    posRoleList(data: any, page: any, pageSize: any): Observable<any> {
        return this.http
            .post<any>(this.posUserService + `/role/get?page=${page}&pageSize=${pageSize}`, data)
            .pipe(catchError((err) => throwError(err)));
    }

    createWallet(data: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/wallet`, data)
            .pipe(catchError((err) => throwError(err)));
    }

    deleteWallet(id: any): Observable<any> {
        return this.http
            .delete<any>(this.userService + `/wallet/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    // Team Member

    checkTeamMemberExistByPhone(payload: any): Observable<any> {
        return this.http
            .post<any>(this.posUserService + `/team/check-mobile`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    sendSMSOtpTeam(payload: any): Observable<any> {
        return this.http
            .post<any>(this.posUserService + `/team/send-sms-otp`, payload, {
                headers: this.noAuth,
            })
            .pipe(catchError((err) => throwError(err)));
    }

    verifySMSOtpTeam(payload: any): Observable<any> {
        return this.http
            .post<any>(this.posUserService + `/team/verify-sms-otp`, payload, {
                headers: this.noAuth,
            })
            .pipe(catchError((err) => throwError(err)));

    }

    // Browsing History

    getUserActionHistory(data: any, page: any = 0, pageSize: any = 10): Observable<any> {
        return this.http
            .post<any>(this.userService + `/browsing-history/search?page=${page}&pageSize=${pageSize}`, data)
            .pipe(catchError((err) => throwError(err)));
    }


    // Product History
    getUserProductsHistory(data: any, page: any = 0, pageSize: any = 10): Observable<any> {
        return this.http
            .post<any>(this.userService + `/browsing-history/viewed-products?page=${page}&pageSize=${pageSize}`, data)
            .pipe(catchError((err) => throwError(err)));
    }


    // product by customer id
    getProductsByCustomer(payload: any, page: number = 1, pageSize: number = 10): Observable<any> {
        return this.http
            .post<any>(this.userService + `/customCatalogue/products-by-customer?page=${page}&pageSize=${pageSize}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    // QnaTemplate
    getAllTemplateQna(payload: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/qnaTemplate/all`, payload)
            .pipe(catchError((err) => throwError(err)));
    }
    getTemplateQnaById(id: any): Observable<any> {
        return this.http
            .get<any>(this.userService + `/qnaTemplate/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }
    createTemplateQna(payload: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/qnaTemplate`, payload)
            .pipe(catchError((err) => throwError(err)));
    }
    updateTemplateQna(id: any, payload: any): Observable<any> {
        return this.http
            .put<any>(this.userService + `/qnaTemplate/${id}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }
    deleteTemplateQna(id: any): Observable<any> {
        return this.http
            .delete<any>(this.userService + `/qnaTemplate/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    //shopQna
    getShopQnaById(id: any): Observable<any> {
        return this.http
            .get<any>(this.userService + `/shopQna/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }
    createShopQna(id: any, payload: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/shopQna/${id}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }
    updateShopQna(id: any, payload: any): Observable<any> {
        return this.http
            .put<any>(this.userService + `/shopQna/${id}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }
    deleteShopQna(id: any): Observable<any> {
        return this.http
            .delete<any>(this.userService + `/shopQna/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    //UAAH LOG

    addUaahLog(payload: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/UAAH`, payload)
            .pipe(catchError((err) => throwError(err)));
    }
    getUaahLog(payload: any, page: any = 1, pageSize: any = 1000000): Observable<any> {
        return this.http
            .post<any>(this.userService + `/UAAH/get-by-criteria?page=${page}&pageSize=${pageSize}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }
    getUaahLogById(id: any): Observable<any> {
        return this.http
            .get<any>(this.userService + `/UAAH/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }
    getUAAHUniqueObjectTypesAndNames(): Observable<any> {
        return this.http
            .get<any>(this.userService + `/UAAH/get-headings`)
            .pipe(catchError((err) => throwError(err)));
    }

    exportCustomers(payload: any): Observable<any> {
        return this.http
            .post<any>(this.userService + `/export-customers`, payload)
            .pipe(catchError((err) => throwError(err)));
    }


}
